export default __webpack_public_path__ + "static/media/35fa3ca53a4044f83e2bb2aaccb10337.svg";